import * as React from "react";
import "./loader.scss";

import classNames from "classnames";
import { Spin } from "antd";

type LoaderProps = {
  isInset?: boolean;
  size?: "small" | "medium" | "large";
};

export default function Loader({
  isInset = false,
  size = "medium",
}: Readonly<LoaderProps>) {
  const classes: string = classNames([
    "loader",
    { "loader--inset": isInset, [`loader--${size}`]: true },
  ]);

  return (
    <div className={classes}>
      <div className="lds-grid">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
}

type LoaderWrapProps = {
  isInset?: boolean;
  isLoading: boolean;
  children: React.ReactNode;
};

export function LoaderWrap({
  isInset = false,
  children,
  isLoading,
}: Readonly<LoaderWrapProps>) {
  return (
    <Spin
      spinning={isLoading}
      wrapperClassName="loader--wrap"
      indicator={<Loader isInset={isInset} />}
    >
      {children}
    </Spin>
  );
}
